// @flow

import React, { PureComponent } from "react";
import { noop } from "lodash";
import type { UnaryFn } from "@tvg/types/Functional";
import formatCurrency, {
  formatCurrencyShortened
} from "@tvg/formatter/currency";
import { arrowDown } from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";
import {
  SelectList,
  AmountSelectorContainer,
  AmountLabelsWrapper,
  AmountValue,
  SelectIcon,
  WagerNumber
} from "./styled-components";

type Props = {
  selectedBetAmount: number,
  onChangeBetAmount: UnaryFn<number, mixed>,
  betAmounts: number[],
  hasOtherAmount: boolean,
  numberOfWager: number
};

export default class AmountSelector extends PureComponent<Props> {
  static defaultProps = {
    selectedBetAmount: 0,
    onChangeBetAmount: noop,
    betAmounts: [],
    hasOtherAmount: false,
    numberOfWager: 0
  };

  getBetAmounts = () => {
    const newBetAmounts = this.props.betAmounts.slice();
    if (
      this.props.selectedBetAmount > 0 &&
      newBetAmounts.indexOf(this.props.selectedBetAmount) === -1
    ) {
      newBetAmounts.push(this.props.selectedBetAmount);
    }
    return newBetAmounts.sort((a, b) => a - b);
  };

  getFormattedBetAmount = () => {
    return this.props.selectedBetAmount > 1000
      ? formatCurrencyShortened(this.props.selectedBetAmount)
      : formatCurrency(this.props.selectedBetAmount);
  };

  render() {
    const betAmounts = this.getBetAmounts();
    const { numberOfWager } = this.props;
    const selectedBetAmount = this.getFormattedBetAmount();
    return (
      <AmountSelectorContainer>
        <AmountLabelsWrapper>
          <WagerNumber>{`WAGER ${
            numberOfWager > 1 ? `(X${numberOfWager})` : ""
          }`}</WagerNumber>
          <AmountValue data-qa-label="betTicket-amountSelectorValue">
            {selectedBetAmount}
          </AmountValue>
        </AmountLabelsWrapper>
        <SelectList
          onChange={(event) => {
            this.props.onChangeBetAmount(+event.target.value);
          }}
          value={this.props.selectedBetAmount}
        >
          {betAmounts.map((amount: number) => (
            <option key={`betamount-${amount}`} value={amount}>
              {formatCurrency(amount)}
            </option>
          ))}
          {this.props.hasOtherAmount && (
            <option key="betamount-other" value="0">
              Other
            </option>
          )}
        </SelectList>
        <SelectIcon
          icon={arrowDown}
          size={16}
          color={buildColor("blue", "500")}
        />
      </AmountSelectorContainer>
    );
  }
}
